// extracted by mini-css-extract-plugin
export default {"tableRowV8":"Row_tableRow__sAiHy","rowOptionsCell":"RowOptionsCell_rowOptionsCell__1Xl5t"};